"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'accountGrade.form.title.edit': 'Edit Price Package',
    'accountGrade.form.title.add': 'Add Price Package',
    'accountGrade.form.back': 'Back',
    'accountGrade.form.name.label': 'Name',
    'accountGrade.form.name.placeholder': 'Price package name',
    'accountGrade.form.description.label': 'Description',
    'accountGrade.form.description.placeholder': 'Price package description',
    'accountGrade.form.price.label': 'Monthly Price',
    'accountGrade.form.price.placeholder': 'Monthly price (in USD)',
    'accountGrade.form.price.monthly.help': 'Monthly subscription price in USD',
    'accountGrade.form.yearlyPrice.placeholder': 'Yearly price (in USD)',
    'accountGrade.form.yearlyPrice.help': 'Yearly subscription price in USD (usually discounted)',
    'accountGrade.form.creditsPerMonth.placeholder': 'Number of credits given per month',
    'accountGrade.form.creditsPerMonth.help': 'Credits are automatically added to user accounts each month',
    'accountGrade.form.advancedPrompts.label': 'Advanced Prompts',
    'accountGrade.form.advancedPrompts.description': 'Allow users to access advanced prompting features',
    'accountGrade.form.promptAssist.label': 'Prompt Assist',
    'accountGrade.form.promptAssist.description': 'Provide assistance with prompt creation',
    'accountGrade.form.maxAvatars.label': 'Max Avatars',
    'accountGrade.form.maxAvatars.placeholder': 'Maximum number of avatars (leave empty for unlimited)',
    'accountGrade.form.maxUsers.label': 'Max Users',
    'accountGrade.form.maxUsers.placeholder': 'Maximum number of users (leave empty for unlimited)',
    'accountGrade.form.maxProjectsCount.label': 'Max Projects',
    'accountGrade.form.maxProjectsCount.placeholder': 'Maximum number of projects (leave empty for unlimited)',
    'accountGrade.form.maxKnowledgeEntries.label': 'Max Knowledge Entries',
    'accountGrade.form.maxKnowledgeEntries.placeholder': 'Maximum number of knowledge entries (leave empty for unlimited)',
    'accountGrade.form.antiHallucination.label': 'Anti-Hallucination',
    'accountGrade.form.antiHallucination.description': 'Enable anti-hallucination features',
    'accountGrade.form.advancedReports.label': 'Advanced Reports',
    'accountGrade.form.advancedReports.description': 'Access advanced reporting features',
    'accountGrade.form.chatThreadSharing.label': 'Chat Thread Sharing',
    'accountGrade.form.chatThreadSharing.description': 'Allow sharing of chat threads',
    'accountGrade.form.customBranding.label': 'Custom Branding',
    'accountGrade.form.customBranding.description': 'Enable custom branding options',
    'accountGrade.form.widgets.label': 'Widgets',
    'accountGrade.form.widgets.description': 'Access to widget functionality',
    'accountGrade.form.customAiModels.label': 'Custom AI Models',
    'accountGrade.form.customAiModels.description': 'Allow custom AI model configurations',
    'accountGrade.form.voiceAgent.label': 'Voice Agent',
    'accountGrade.form.voiceAgent.description': 'Enable voice agent functionality',
    'accountGrade.form.writingStyles.label': 'Writing Styles',
    'accountGrade.form.writingStyles.description': 'Access to writing style features',
    'accountGrade.form.save': 'Save Price Package',
    'accountGrade.form.saving': 'Saving...',
    'accountGrade.form.unlimited': 'Unlimited',
    'accountGrade.form.active.label': 'Active',
    'accountGrade.form.active.description': 'Make this price package available',
    'accountGrade.form.order.label': 'Order',
    'accountGrade.form.order.placeholder': 'Display order (optional)',
    'accountGrade.form.createSuccess': 'Price package created successfully',
    'accountGrade.form.updateSuccess': 'Price package updated successfully',
    'accountGrade.form.saveError': 'Failed to save price package',
    'accountGrade.form.submit.create': 'Create Price Package',
    'accountGrade.form.submit.update': 'Update Price Package',
};
